import { createContext, ReactNode } from 'react';

export type ModalVariant = 'info' | 'success' | 'error';

export interface Modal {
  variant?: ModalVariant;
  header: string;
  body: ReactNode;
  button?: ReactNode;
  onClose?: (options: { actionButtonClicked: boolean }) => void;
  onButtonClick?: () => void;
}

export interface Context {
  modal: Modal | null;
  showModal: (options: Modal) => void;
  hideModal: () => void;
}

const ModalContext = createContext<Context>({
  modal: null,
  showModal: () => {},
  hideModal: () => {},
});

export default ModalContext;
